import React from "react";
import {connect} from "react-redux";
import {replace} from 'react-router-redux';
import {Row, Modal, Button, Tabs, Tab} from 'react-bootstrap';
import SelectionTabs from "../../components/common/SelectionTabs";
import SelectionPane from "../../components/common/SelectionPane";
import JoinPickupSiteList from "../../components/join/JoinPickupSiteList";
import JoinPickupSiteMap from "../../components/join/JoinPickupSiteMap";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {setPickupSitesFilters, getGuestPickupSiteData, setMapProps, initMapProps, navigateToStep} from "../../actions/join/joinActions";
import {URLs, PickupSiteTypes, FetchingTypes, JoinStepsDirections} from "../../common/constants";
import {setWaitListPickupSite, setPickupSitesAndDeliveryDateActual} from "../../actions/common/subscriptionSummaryActions";
import {isEmptyObj, getUrlParams} from "../../common/utils";
import {setDirty} from "../../actions/common/commonActions";
import {isFetching, errorFetching} from "../../actions/common/fetchingActions";
import ModalPopup from"../../components/common/ModalPopup";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/join/pickupSiteListSelection.less";

const PICKUP_SITE_LIST_TAB = translate("LIST");
const PICKUP_SITE_MAP_TAB = translate("MAP");

class PickupSiteSelection extends React.Component {
    state = {
        availablePickupSites: [],
        waitListPickupSites: [],
        selectionError: undefined
    };

    componentWillMount() {
        if(this.props.isGuestUser) {
            this.props.getGuestPickupSiteData();
        }
        const pickupSiteKey = getUrlParams().location;
        if (pickupSiteKey) {
            this.props.removePath();
            const pickupSites = this.props.pickupSitesData.pickupSites.find(pickupSite => pickupSite.key === pickupSiteKey);
            if (pickupSites && pickupSites.isAvailable) {
                this.setPickupSite(pickupSites, false);
                this.props.navigateToSharesStep();
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.deliveryDay !== nextProps.deliveryDay) {
            this.props.initMapProps();
        }
    }

    getPickupSites = () => {
        let pickupSites = this.props.pickupSitesData.pickupSites;
        let deliveryDayFilter = this.props.deliveryDay?this.props.deliveryDay:null;
        if (pickupSites) {
            let availablePickupSites = [];
            for (let i = 0; i < pickupSites.length; i++) {
                let pickupSite = pickupSites[i];
                if(pickupSite.type !== PickupSiteTypes.ZONE && pickupSite.type !== PickupSiteTypes.REGULAR) {
                    continue;
                }
                if(deliveryDayFilter !== null && pickupSite.deliveryDays !== deliveryDayFilter) {
                    continue;
                }
                if (this.props.staticData.joinHideRegularPickupSiteHours && pickupSite.type === PickupSiteTypes.REGULAR) {
                    pickupSite.deliveryHours = "";
                }

                availablePickupSites.push(Object.assign({}, pickupSite, {isNonSelectable: !this.isSelectable(pickupSite)}));
            }
            return availablePickupSites;
        }
    };

    isSelectable = (pickupSite) => {
        let nextDeliveryDates = this.props.pickupSitesData.nextDeliveryDates;
        let exceptionalPickupSites = this.props.pickupSitesData.exceptionalPickupSites;
        const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
        let hasDelivery = nextDeliveryDates.hasOwnProperty(pickupSiteDeliveryDay) && !isEmptyObj(nextDeliveryDates[pickupSiteDeliveryDay])
            || exceptionalPickupSites.hasOwnProperty(pickupSite.key);

        const selectable = this.isInAvailableDays(pickupSite) && hasDelivery;
        if(selectable && this.props.flowType === URLs.ACCOUNT && !this.isPickupSiteAvailableForSubscription(pickupSite)) {
            return false;
        }
        return selectable;
    };

    isInAvailableDays = (pickupSite) => {
        let availableDays = this.props.pickupSitesData.availableDays;
        let exceptionsDaysAndHours = this.props.pickupSitesData.exceptionsDaysAndHours;
        let exceptionalPickupSites = this.props.pickupSitesData.exceptionalPickupSites;
        let pickupSiteDeliveryDay = pickupSite.deliveryDaysList?pickupSite.deliveryDaysList[0]:null;
        let exceptionDeliveryDate = exceptionalPickupSites[pickupSite.key];
        return (availableDays === undefined) || availableDays.includes(pickupSiteDeliveryDay) ||
            (exceptionDeliveryDate && exceptionsDaysAndHours.hasOwnProperty(exceptionDeliveryDate) &&
                exceptionsDaysAndHours[exceptionDeliveryDate]["second"])
    };

    isVisibleToMember = (pickupSite, scheduledShareItem) => {
        return this.isVisibleForPickupSite(pickupSite, scheduledShareItem.shareItem) && (!scheduledShareItem.shareItem.isAvailable ||
        scheduledShareItem.selectedSchedule != -2 && (scheduledShareItem.selectedSchedule == -1 &&
        scheduledShareItem.shareItem.defaultSchedulesSize > 1 || this.isDeliveriesLeft(scheduledShareItem)));
    };

    isVisibleForPickupSite = (pickupSite, shareItem) => {
        return pickupSite == null || shareItem.pickupSiteNotAvailableSet && !shareItem.pickupSiteNotAvailableSet.includes(pickupSite.key);
    };

    isDeliveriesLeft = (scheduledShareItem) => {
        return scheduledShareItem.selectedSchedule >= 0 &&
            scheduledShareItem.selectedSchedule < scheduledShareItem.shareItem.isDeliveriesLeft.length ?
                scheduledShareItem.shareItem.isDeliveriesLeft[scheduledShareItem.selectedSchedule] : false;
    };

    isPickupSiteAvailableForSubscription = (pickupSite) => {
        const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
        const shareItemData = this.props.pickupSitesData.shareItemDataMap[pickupSiteDeliveryDay];

        // If at least one share becomes unavailable for this pick up site don't allow to select this pick up site
        const summaryShareItems = this.props.shareItems;
        for (let i in summaryShareItems) {
            if (summaryShareItems.hasOwnProperty(i)){
                let scheduledShareItem;
                const shareKey = summaryShareItems[i].key;
                if (shareItemData && shareItemData.shareItems.length) {
                    const shareItems = shareItemData.shareItems;
                    for (let j in shareItems) {
                        if (shareItems.hasOwnProperty(j)) {
                            const shareItem = shareItems[j];
                            if (shareItem.key === shareKey) {
                                scheduledShareItem = this.getSelectionIndex(shareItem, this.props.shareSchedules[i]);
                                this.updateSelectedSchedule(pickupSite, scheduledShareItem);
                                break;
                            }
                        }
                    }
                }
                if (scheduledShareItem && !this.isVisibleToMember(pickupSite, scheduledShareItem)) {
                    return false;
                }
            }
        }
        return true;
    };

    updateSelectedSchedule = (pickupSite, scheduledShareItem) => {
        const item = scheduledShareItem.shareItem;
        if(this.isVisibleForPickupSite(pickupSite, item) && item.defaultSchedulesSize <= 1) {
            scheduledShareItem.selectedSchedule = pickupSite && item.pickupSiteScheduleMap && item.pickupSiteScheduleMap.hasOwnProperty(pickupSite.key) &&
            item.pickupSiteScheduleMap[pickupSite.key] !== -1 ? item.pickupSiteScheduleMap[pickupSite.key] : item.defaultSchedulesSize-1;
        }
    };

    getSelectionIndex = (shareItem, scheduleKey) => {
        let selectedSchedule =  -1;

        if (scheduleKey !== null) {

            for (let i = 0; i < shareItem.schedules.length; i++) {

                if (shareItem.schedules[i]=== scheduleKey) {
                    selectedSchedule = i;
                    break;
                }
            }
        }
        return {
            shareItem: shareItem,
            selectedSchedule: selectedSchedule
        }
    };

    isValidChangeWhenWebOrderExists = (pickupSite) => {
        const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
        const subscriptionPickupSiteDeliveryDay = (this.props.pickupSite.deliveryDaysList || this.props.pickupSite.deliveryDaysList !== null)?
                                                    this.props.pickupSite.deliveryDaysList[0]:null;
        return pickupSiteDeliveryDay === subscriptionPickupSiteDeliveryDay;
    };

    getStoreHours = (pickupSite) => {
        const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
        if (this.props.pickupSitesData.storeHours && this.props.pickupSitesData.storeHours.hasOwnProperty(pickupSiteDeliveryDay))
            return this.props.pickupSitesData.storeHours[pickupSiteDeliveryDay];
        const deliveryDate = this.props.pickupSitesData.exceptionalPickupSites[pickupSite.key];
        return (deliveryDate && this.props.pickupSitesData.exceptionsDaysAndHours[deliveryDate]?
            this.props.pickupSitesData.exceptionsDaysAndHours[deliveryDate]:"");
    };

    isValidPickupSiteSelection = (pickupSite) => {
        if(this.props.flowType === URLs.ACCOUNT && !this.isPickupSiteAvailableForSubscription(pickupSite)) {
            this.setState({selectionError: translate("pickupSiteNotAvailableForSubscription")});
            return false;
        }
        if(pickupSite.isNonSelectable) {
            if(this.props.flowType === URLs.ACCOUNT) {
                const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
                this.setState({selectionError:translate("pickupSiteNotChangeDistributionDay").replace("DELIVERY_DAY", pickupSiteDeliveryDay)});
                return false;
            } else if(this.props.flowType === URLs.JOIN){
                const storeHours = this.getStoreHours(pickupSite);
                if(storeHours) {
                    this.setState({selectionError:translate("guestStoreClosedSeasonEnd") + "</br></br>" + translate("pickupSiteNotAvailablePrepareDeliveries") + storeHours + "."});
                    return false;
                } else {
                    this.setState({selectionError:translate("guestStoreClosedSeasonEnd")});
                    return false;
                }
            }
            return false;
        } else if(this.props.flowType === URLs.ACCOUNT && this.props.activeWebOrderKey && !this.isValidChangeWhenWebOrderExists(pickupSite)) {
            this.setState({selectionError:translate("cantAcceptChangesActiveOrder")});
            return false;
        }
        this.setState({selectionError:undefined});
        return true;
    };

    showPopupError = () => {
        return(
        <ModalPopup
            onClose={()=>{this.setState({selectionError:undefined})}}
            title=""
            message={this.state.selectionError}
            middle={{text:translate('Close'), callback:()=>{this.setState({selectionError:undefined})}}}/>);
    };

    setPickupSite = (pickupSite, isWaitList) => {
        let nextDeliveryDate = this.props.nextDeliveryDate;
        const pickupSiteDeliveryDay = (pickupSite.deliveryDaysList || pickupSite.deliveryDaysList !== null)?pickupSite.deliveryDaysList[0]:null;
        if(this.props.pickupSitesData && this.props.pickupSitesData.nextDeliveryDates.hasOwnProperty(pickupSiteDeliveryDay)){
            const deliveryDates = this.props.pickupSitesData.nextDeliveryDates[pickupSiteDeliveryDay];
            for(let key in deliveryDates) {
                if (deliveryDates.hasOwnProperty(key)) {
                    nextDeliveryDate = deliveryDates[key];
                    break;
                }
            }
        }
        this.props.updatePickupSitesAndDeliveryDate(pickupSite, isWaitList, nextDeliveryDate);
    };

    getPickupSiteListView = () => {
        return (<JoinPickupSiteList clientViewPort={this.props.clientViewPort}
                                    availablePickupSites={this.getPickupSites()}
                                    setPickupSite={this.setPickupSite}
                                    pickupSiteKey={this.props.pickupSite.key}
                                    pickupSiteWaitListKey={this.props.pickupSiteWaitListKey}
                                    deliveryDayFilter={this.props.deliveryDay}
                                    setDeliveryDayFilter={this.props.setDeliveryDayFilter}
                                    pickupSites={this.props.pickupSitesData.pickupSites}
                                    overrideSignupDaysColumnLabel={this.props.staticData.overrideSignupDaysColumnLabel}
                                    joinWaitListLocationLabel={this.props.staticData.joinWaitListLocationLabel}
                                    isValidPickupSiteSelection={this.isValidPickupSiteSelection}/>);
    };

    getPickupSiteMapView = () => {
        return (<JoinPickupSiteMap clientViewPort={this.props.clientViewPort}
                                   availablePickupSites={this.getPickupSites()}
                                   setPickupSite={this.setPickupSite}
                                   setMapProps={this.props.setMapProps}
                                   centerLocation={this.props.centerLocation}
                                   deliveryDayFilter={this.props.deliveryDay}
                                   setDeliveryDayFilter={this.props.setDeliveryDayFilter}
                                   pickupSites={this.props.pickupSitesData.pickupSites}
                                   zoomLevel={this.props.zoomLevel}
                                   isValidPickupSiteSelection={this.isValidPickupSiteSelection}
                                   errorFetching={this.props.errorFetching}/>);
    };

    render() {
        if (this.props.showLoading)
            return <LoadingAnimation/>;
        const pickupSiteLabel = !this.props.staticData.pickupSiteLabel || this.props.staticData.pickupSiteLabel === 'null'
            ? translate("pick-up site") : this.props.staticData.pickupSiteLabel;
        const title = translate("pickupDayStepHeader").replace("PICKUP_SITE_LABEL", pickupSiteLabel);
        const showMapFirst = this.props.staticData.joinShowMapFirst;
        if (this.props.clientViewPort.isXs) {
            return (<div className={"pickup-site-select-container pickup-site-selection-mobile" + (this.props.flowType === URLs.ACCOUNT ? " account" : "")}>
                <Tabs className="join-mobile-tab" id="pickup-sites-tabs" defaultActiveKey={PICKUP_SITE_LIST_TAB} animation={false} unmountOnExit={true}>
                    <Tab title={PICKUP_SITE_LIST_TAB} eventKey={PICKUP_SITE_LIST_TAB}>
                        {this.getPickupSiteListView()}
                    </Tab>
                    <Tab title={PICKUP_SITE_MAP_TAB} eventKey={PICKUP_SITE_MAP_TAB}>
                        {this.getPickupSiteMapView()}
                    </Tab>
                </Tabs>
                {
                    !this.state.selectionError ? undefined :
                        this.showPopupError()
                }
            </div>);
        } else {
            return (<div className="table-container-selector pickup-site-select-container">
                <div className="select-title">{title}</div>
                <SelectionTabs className="pickup-sites-tabs" id="pickup-sites-tabs">
                    <SelectionPane label={showMapFirst ? PICKUP_SITE_MAP_TAB : PICKUP_SITE_LIST_TAB}>
                        {showMapFirst ? this.getPickupSiteMapView() : this.getPickupSiteListView()}
                    </SelectionPane>
                    <SelectionPane label={showMapFirst ? PICKUP_SITE_LIST_TAB : PICKUP_SITE_MAP_TAB}>
                        {showMapFirst ? this.getPickupSiteListView() : this.getPickupSiteMapView()}
                    </SelectionPane>
                </SelectionTabs>
                {
                    !this.state.selectionError ? undefined :
                        this.showPopupError()
                }
            </div>);
        }
    }
}

const mapStateToProps = (state) => {
    const pickupSiteData = (state.signupData.pickupSitesData||{});
    const signupData = (state.signupData || {});
    const summary = (state.summary || {});
    return {
        staticData: state.staticData,
        clientViewPort: (state.clientViewPort || {}),
        showLoading: isFetching(state, FetchingTypes.LOAD_SIGNUP_DATA) || isFetching(state, FetchingTypes.LOAD_PICKUP_DATA) || !state.signupData.pickupSitesData,
        memberDetails: (state.memberDetails || {}),
        isGuestUser : signupData.isGuestUser,
        zoomLevel: signupData.zoomLevel,
        centerLocation: signupData.centerLocation,
        pickupSitesData: pickupSiteData,
        pickupSite: (summary.pickupSite || {} ),
        pickupSiteWaitListKey: (summary.waitListSite || {}).key,
        shareItems: summary.shareItems,
        shareSchedules: summary.shareSchedules,
        activeWebOrderKey: summary.activeWebOrderKey,
        nextDeliveryDate: summary.nextDeliveryDate,
        deliveryDay: pickupSiteData.deliveryDayFilter
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        updatePickupSitesAndDeliveryDate: (pickupSite, isWaitList, nextDeliveryDate) => {
            if(!isWaitList) {
                dispatch(setPickupSitesAndDeliveryDateActual(pickupSite, nextDeliveryDate));
            } else {
                dispatch(setWaitListPickupSite(pickupSite));
            }
            dispatch(setDirty(true));
        },
        setDeliveryDayFilter: (deliveryDay) => {
            dispatch(setPickupSitesFilters(deliveryDay));
        },
        getGuestPickupSiteData: () => {
            dispatch(getGuestPickupSiteData());
        },
        setMapProps:(zoomLevel, centerLocation) => {
            dispatch(setMapProps(zoomLevel, centerLocation));
        },
        initMapProps: () => {
            dispatch(initMapProps());
        },
        errorFetching: (error) => {
            dispatch(errorFetching(error));
        },
        removePath: () => {
            dispatch(replace(location.pathname));
        },
        navigateToSharesStep: () => {
            dispatch(navigateToStep(JoinStepsDirections.NEXT));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(PickupSiteSelection);



// WEBPACK FOOTER //
// ./src/containers/common/PickupSiteSelection.js